import { LineStyleSwatchComponent } from './line-style-swatch/line-style-swatch.component';
import { DashID, LineThicknesses } from 'app/types/drawing/dashed-lines';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChildren, QueryList } from '@angular/core';

@Component({
  selector: 'app-attribute-option-line-styler',
  templateUrl: './attribute-option-line-styler.component.html',
  styleUrls: ['./attribute-option-line-styler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeOptionLineStylerComponent implements OnInit {

  constructor(private cdr: ChangeDetectorRef) { }
  public swatchWidth = 100;
  public swatchHeight = 18;

  private _thickness: number = 2; // LineThicknesses.medium
  @Input()
  set thickness(width: LineThicknesses) {
    this._thickness = width;
    this.Refresh();

  }
  get thickness(): LineThicknesses {
    return this._thickness;
  }
  private _color: string = '#000';
  @Input()
  set color(c: string) {
    this._color = c;
    this.Refresh();
  }
  get color(): string {
    return this._color;
  }
  private _dashes = [DashID.solid,
  DashID.dlgl, DashID.dmgm, DashID.dsgs,
  DashID.dlgm, DashID.dmgs, DashID.dsgd,
  DashID.dldgm, DashID.dmdgs, DashID.dsdgd,
  DashID.dlddgm, DashID.dmddgs, DashID.dsddgd,
  DashID.dldddgm, DashID.dmdddgs, DashID.dsdddgd,
  DashID.dgm, DashID.dgs, DashID.dgd];
  get dashes(): Array<DashID> {
    return this._dashes;
  }
  private _selected: DashID = DashID.solid;
  @Input()
  public set selected(dash: DashID) {
    this._selected = dash;
    this.Refresh();
    this.selections.emit(this._selected);
  }
  public get selected(): DashID {
    return this._selected;
  }
  @Output()
  public selections = new EventEmitter<DashID>();
  @Output()
  public enters = new EventEmitter<DashID>();
  public get solidDash(): DashID { return DashID.solid; };

  @ViewChildren(LineStyleSwatchComponent) lineStyles?: QueryList<LineStyleSwatchComponent>;

  ngOnInit(): void {
  }
  Refresh() {
    this.cdr.detectChanges();
  }
  CanAddBreak(index: number) {
    return index % 3 === 0
  }
  SelectSwatch(swatch: DashID, asEnter: boolean = false) {
    this.selected = swatch;
    if (!!this.lineStyles) {
      this.lineStyles.toArray()[this._dashes.indexOf(swatch)].Focus();
    }
    if (asEnter) {
      this.enters.emit(this.selected);
    }
  }
  GetDash(idx: number):DashID {
    return this._dashes[idx];
  }
  NoSort(): number {
    return 0;
  }
  HandleKey(event: KeyboardEvent, index: number) {
    if (!this.lineStyles) return;
    switch (event.code) {
      case 'ArrowLeft':
        if (index > 0) {
          index -= 1;
        }
        break;
      case 'ArrowRight':
        if (index < this.dashes.length - 1) {
          index += 1;
        } break;
      case 'ArrowUp':
        if (index >= 1 && index <= 3) {
          index = 0;
        } else if (index >= 3) {
          index -= 3;
        }
        break;
      case 'ArrowDown':
        if (index === 0) {
          index = 1;
        } else if (index < (this.dashes.length - 3)) {
          index += 3;
        }
        break;
      case 'Space':
        this.SelectSwatch(this.dashes[index]);
        break;
      case 'Enter':
        this.SelectSwatch(this.dashes[index], true);
        break;
    }
    this.lineStyles.toArray()[index].Focus();
  }
  HandleDoubleClick(event:MouseEvent,id:DashID) {
    this.SelectSwatch(id,true);
    event.preventDefault();
    if(event.cancelable === true) {
      event.stopImmediatePropagation();
    }

  }
}
